export default [
  {
    text: "2021年企业信息公开年报",
    url: "/pdf/messageGknb/2021年企业信息公开年报.pdf",
  },
  {
    text: "2020年企业信息公开年报",
    url: "/pdf/messageGknb/2020年企业信息公开年报.pdf",
  },
  {
    text: "2019年企业信息公开年报",
    url: "/pdf/messageGknb/2019年企业信息公开年报.pdf",
  },
  {
    text: "2018年企业信息公开年报",
    url: "/pdf/messageGknb/2018年企业信息公开年报.pdf",
  },
  {
    text: "2017年企业信息公开年报",
    url: "/pdf/messageGknb/2017年企业信息公开年报.pdf",
  },
  {
    text: "2016年企业信息公开年报",
    url: "/pdf/messageGknb/2016年企业信息公开年报.pdf",
  },
];
